export default "__VITE_ASSET__3cb4aebe__"